import React, { 
  useCallback, useContext, useEffect, useMemo, useState 
} from 'react';
import { publishPiplineRequest } from '../../utils/api_functions/publishPipelineRequest';

import useClientContext from '../contexts/ClientData/ClientData';
import useListPublishesForPipeline from './useListPublishesForPipeline';
import usePipelineData from '../pipelines/PipelineDataContext';

const PublishPipelineContext = React.createContext({
  currentPipelineId: null,
  listOfEdgesForPipelines: [],
  listOfPublishesForPipeline: [],
  selectedEdgeLocations: [],
  newPublish: false,
  isLoading: false,
  isEdgeSelected: false,
  error: null,
  publishRequest: () => {},
  setNewPublish: () => {},
  setSelectedEdgeLocations: () => {},
})

export const PublishPipelineProvider = ({ children }) => {
  const [newPublish, setNewPublish] = useState(true);
  const [listOfEdgesForPipelines, setListOfEdgesForPipelines] = useState([])
  const [listOfPublishesForPipeline, setListOfPublishesForPipeline] = useState([])
  const [selectedEdgeLocations, setSelectedEdgeLocations] = useState([]);

  const { pipeline } = usePipelineData();
  const pipelineId = pipeline?.id;

  const { isEdgeEnabled, isEdgePublishingEnabled } = useClientContext();
  const { data, error, isLoading } = useListPublishesForPipeline(pipelineId, newPublish, isEdgeEnabled, isEdgePublishingEnabled)

  const isEdgeSelected = useMemo(() => selectedEdgeLocations?.length > 0, [selectedEdgeLocations]);

  const publishRequest = useCallback((engineConfig, modelConfigIds, pipelineVersionId) => {
    if (!isEdgePublishingEnabled) {
      return;
    }
    publishPiplineRequest(engineConfig, modelConfigIds, pipelineVersionId).then(() => {
      setNewPublish(true)
    })
  }, [isEdgePublishingEnabled])

  useEffect(() => {
    if (isEdgePublishingEnabled && data?.publishes) {
      setListOfPublishesForPipeline(data.publishes);
    } else {
      setListOfPublishesForPipeline([])
    }
    if (isEdgeEnabled && data?.edges) {
      setListOfEdgesForPipelines(data.edges);
    } else {
      setListOfEdgesForPipelines([])
      setSelectedEdgeLocations([]);
    }
  }, [data, isEdgeEnabled, isEdgePublishingEnabled])

  const publishPipelineContextValue = useMemo(() => ({
    currentPipelineId: pipelineId,
    listOfEdgesForPipelines,
    listOfPublishesForPipeline,
    selectedEdgeLocations: selectedEdgeLocations || [],
    isEdgeSelected,
    newPublish,
    publishRequest,
    setNewPublish,
    setSelectedEdgeLocations,
    error,
    isLoading
  }), [pipelineId, error, isEdgeSelected, isLoading, listOfEdgesForPipelines, listOfPublishesForPipeline, newPublish, publishRequest, selectedEdgeLocations])

  return (
    <PublishPipelineContext.Provider value={publishPipelineContextValue}>
      {children}
    </PublishPipelineContext.Provider>
  )
}

// Just an alias for convenience
export const usePipelineEdgeData = () => useContext(PublishPipelineContext)

export const usePublishPipelineData = () => useContext(PublishPipelineContext)

export default usePublishPipelineData;
